import { useEffect } from 'react'

import { env } from '@/shared/config'

// Промежуточная страница: уводит человека без действующей подписки на прайсинг
// Академии. Отдельный внутренний маршрут нужен, потому что переходы после входа
// идут через react-router navigate()/<Link>, а они умеют только внутренние пути.
export function AcademyRedirectPage() {
  useEffect(() => {
    window.location.replace(env.academyPricingUrl)
  }, [])

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#080808',
        color: '#FEFEFE',
        fontFamily: 'system-ui, sans-serif',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <p>
        Открываем Академию…{' '}
        <a href={env.academyPricingUrl} style={{ color: '#FEFEFE', textDecoration: 'underline' }}>
          Перейти вручную
        </a>
      </p>
    </main>
  )
}

AcademyRedirectPage.displayName = 'AcademyRedirectPage'
